<template>
  <div v-if="loading" class="text-center" style="margin-top: 10em">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else>
    <transition appear name="slide-fade">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header">
              <h4 class="text-orange fw-bold">Cargar anexo</h4>
            </div>
            <div class="card-body">
              <div v-if="loading_upload" class="text-center" style="margin-top: 2em">
                <small class="text-muted">Subiendo archivo...</small><br />
                <div class="lds-roller">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div v-else>
                <label>Cliente</label>

                <div>
                  <label>Anexo</label>
                  <h4 class="fw-bold text-orange">{{ anexo.tipo_anexo }}</h4>
                  <div class="form-group mt-4 mb-4">
                    <label>Archivo</label>
                    <input @change="on_file_change" type="file" class="form-control" />
                  </div>
                  <div v-if="id_tipo_anexo == 3" class="form-group mt-4 mb-4">
                    <label>Fecha de firma del contrato</label>
                    <input v-model="fecha_firma" type="date" class="form-control" />
                  </div>
                  <div class="text-end">
                    <!-- <router-link v-bind:to="'/anexos_membresia/' + id_usuario" class="btn btn-outline-dark rounded-pill">
                      <i class="bx bx-chevron-left"></i> Cancelar
                    </router-link> -->
                    <button type="button" @click="hasHistory()
                      ? $router.go(-1)
                      : $router.push('/')" class="btn btn-outline-dark rounded-pill">
                      <i class="bx bx-chevron-left"></i> Cancelar
                    </button>
                    <button v-on:click="upload" :disabled="
                      file == null ||
                      (id_tipo_anexo == 3 && fecha_firma == null)
                    " class="btn btn-success rounded-pill ms-1">
                      Subir <i class="bx bx-upload"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
  name: "Cargar_anexo",
  data() {
    return {
      loading: true,
      loading_upload: false,
      id_usuario: null,
      id_tipo_anexo: null,
      usuario: [],
      anexo: null,
      hay_archivo: false,
      file: null,
      fecha_firma: null,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_usuario = this.$route.params.id_usuario;
    this.id_tipo_anexo = this.$route.params.id_tipo_anexo;
    this.get_usuario();
  },
  methods: {
    hasHistory() { return window.history.length > 2 },
    get_usuario: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "clientes/cliente/" + this.id_usuario, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.usuario = response.data.data;
          if (this.id_tipo_anexo == 1) {
            this.get_anexo();
          } else {
            if (this.id_tipo_anexo == 4) {
              this.loading = false;
              this.anexo = {
                tipo_anexo: "Guia entrega",
              };
            } else {
              this.loading = false;
              this.anexo = {
                tipo_anexo: "Soporte de pago",
              };
            }
          }
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_anexo: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(
          this.$base_url +
          "membresias/anexo/" +
          this.id_usuario +
          "/" +
          this.id_tipo_anexo,
          config,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.anexo = response.data.data.anexo;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    on_file_change(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.hay_archivo = false;
        return;
      }
      this.file = files;
      this.hay_archivo = true;
    },
    upload: function () {
      this.hay_archivo = false;
      this.loading = true;
      var formData = new FormData();
      formData.append("files", this.file[0]);
      formData.append("token", this.session.token);
      formData.append("id_usuario", this.id_usuario);
      formData.append("id_membresia", this.usuario.membresia.id_membresia);
      formData.append("id_tipo_anexo", this.id_tipo_anexo);
      formData.append("fecha_firma", this.fecha_firma);
      const vm = this;
      axios
        .post(this.$base_url + "upload/anexo_membresia", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status) {
            vm.hay_archivo = false;
            vm.$notify({
              group: "foo",
              type: "success",
              title: "Excelente!",
              text: "Se ha subido el anexo.",
            });
            vm.loading_upload = false;

            vm.file = null;
            if (vm.id_tipo_anexo == 3) {
              vm.$router.push("/contrato_membresia/" + vm.id_usuario);
            } else {
              vm.$router.push("/anexos_membresia/" + vm.id_usuario);
            }
          } else {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Ups!",
              text: response.data.message,
            });
            vm.loading = false;
          }
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Ups",
            text: error,
          });
          console.log(error);
          vm.loading_upload = false;
        });
    },
  },
  mounted: function () { },
};
</script>